import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default  function CallandRegisterComponent(){
  const navigate=useNavigate()

    const closeMenu = () =>{
navigate("/form")
    window.scrollTo({top:0,behavior:"smooth"})
   } 
    return(<div className="mt-3">
       <div className="flex flex-row sm:flex-row gap-4 justify-center md:justify-center">
             <a href="tel:+919959271353" className="flex items-center justify-center">
      <button className="flex font-roboto text-sm items-center justify-center gap-2 bg-[#20b2aa] text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition">
        <FaPhoneAlt />
        +91 99 59 271 353
      </button>
    </a>
    
    <button onClick={closeMenu} className="bg-green-900 text-sm text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition">
     ENQUIRE NOW
     </button>
             
     </div>
    
    
    </div>)



}